import { useEffect, useRef } from 'react';
import { DeviceEventEmitter } from 'react-native';
import { compareVersions } from 'compare-versions';
import { useAppVersion } from '../hooks/useAppVersion';
import { useIsForegroundNow } from '../hooks/useIsForegroundNow';
import { useLogAnalyticsEvent } from '../hooks/useLogAnalyticsEvent';
import { isAndroid, isNotNil } from '../utils';

const MIN_ANDROID_VERSION = '2.363.0';

// BackHandler 체인(LIFO + 선-consume 중단)은 BottomSheet/Modal 이 선점하면 로그 콜백이 호출되지 않음.
// DeviceEventEmitter 의 hardwareBackPress 는 BackHandler 내부 리스너와 별도 구독자라 consume 무관하게 항상 1회 발화.
// useIsForegroundNow 는 foregroundMap[instanceId] 기반이라 멀티 Activity 환경에서도 top 1개만 true.
export const AndroidBackPressLogger = () => {
  const isForeground = useIsForegroundNow();
  const appVersion = useAppVersion();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const isForegroundRef = useRef(isForeground);
  isForegroundRef.current = isForeground;

  const shouldLog =
    isAndroid &&
    isNotNil(appVersion) &&
    compareVersions(appVersion, MIN_ANDROID_VERSION) >= 0;
  const shouldLogRef = useRef(shouldLog);
  shouldLogRef.current = shouldLog;

  useEffect(() => {
    if (!isAndroid) return;
    const sub = DeviceEventEmitter.addListener('hardwareBackPress', () => {
      if (!isForegroundRef.current) return;
      if (!shouldLogRef.current) return;
      logAnalyticsEvent({
        name: 'CLICK_BACK_BUTTON',
        analytics: { IS_LAST_ACTIVITY: false },
      });
    });
    return () => sub.remove();
  }, [logAnalyticsEvent]);

  return null;
};
